var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 28,
    viewBox: "0 0 35 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8257 14.9456L21.8093 26.962C21.3185 27.4528 20.5815 27.5993 19.9394 27.3338C19.2989 27.0682 18.8805 26.4422 18.8805 25.7486V20.6262C7.4466 21.0156 2.96311 25.211 2.91821 25.2559H2.9166C2.37428 25.7837 1.54873 25.8932 0.885702 25.5263C0.222675 25.1577 -0.121692 24.3998 0.0392237 23.6595C0.0746273 23.497 3.69226 8.02067 18.8803 6.92647V1.71586C18.8803 1.02226 19.2987 0.39627 19.9392 0.130713C20.5813 -0.134815 21.3184 0.011628 21.8092 0.502451L33.8256 12.5188C34.1474 12.8407 34.3293 13.2768 34.3293 13.7322C34.3293 14.1877 34.1475 14.6238 33.8256 14.9456L33.8257 14.9456Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a2d95e0c5f0c9038301ad405d64dc591.svg";
export { ForwardRef as ReactComponent };